/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat = ClosedEnum<
  typeof GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat
>;

export type GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest = {
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
  /**
   * Node ID
   */
  nodeId?: string | null | undefined;
};

/** @internal */
export const GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat> = z
    .nativeEnum(GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat);

/** @internal */
export const GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat> =
    GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat$ {
  /** @deprecated use `GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    start: z.nullable(z.number()).default(null),
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat$inboundSchema
      .default("json"),
    step: z.number().default(7200),
    node_id: z.nullable(z.string()).default(null),
  }).transform((v) => {
    return remap$(v, {
      "node_id": "nodeId",
    });
  });

/** @internal */
export type GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest$Outbound = {
  start: number | null;
  end: number | null;
  format: string;
  step: number;
  node_id: string | null;
};

/** @internal */
export const GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest
  > = z.object({
    start: z.nullable(z.number()).default(null),
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsNodeEnergyConsumptionRateKwhFormat$outboundSchema
      .default("json"),
    step: z.number().default(7200),
    nodeId: z.nullable(z.string()).default(null),
  }).transform((v) => {
    return remap$(v, {
      nodeId: "node_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest$ {
  /** @deprecated use `GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest$Outbound;
}

export function getApiV3MetricsNodeEnergyConsumptionRateKwhRequestToJSON(
  getApiV3MetricsNodeEnergyConsumptionRateKwhRequest:
    GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest$outboundSchema.parse(
      getApiV3MetricsNodeEnergyConsumptionRateKwhRequest,
    ),
  );
}

export function getApiV3MetricsNodeEnergyConsumptionRateKwhRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsNodeEnergyConsumptionRateKwhRequest' from JSON`,
  );
}
